// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".router-link-active[data-v-1659d81e],\n.router-link-exact-active[data-v-1659d81e] {\n  background-color: rgb(17, 24, 39);\n  color: #ffffff;\n}\n", ""]);
// Exports
module.exports = exports;
